import { useCallback, useEffect, useState } from "react";

import {
  AnchoredDetailCallout,
  buildAttributeAnchorSelector,
} from "@/components/ui/AnchoredDetailCallout";

import {
  PAPERWORK_PROCESS_WO_ANCHOR_ATTR,
  WorkOrderDetailWorkspace,
} from "./workOrderDetailWorkspace";

const WORK_ORDER_DETAIL_CALLOUT_WIDTH_PX = 32 * 16;

export function WorkOrderDetailAnchoredCallout({
  buildOrderId,
  anchorKey,
  onClose,
  onMutated,
}: {
  buildOrderId: number;
  anchorKey: string;
  onClose: () => void;
  onMutated?: () => void;
}): JSX.Element {
  const [layoutEpoch, setLayoutEpoch] = useState(0);

  useEffect(() => {
    setLayoutEpoch(0);
  }, [buildOrderId]);

  const onDetailReady = useCallback(() => {
    setLayoutEpoch((epoch) => epoch + 1);
  }, []);

  return (
    <AnchoredDetailCallout
      anchorSelector={buildAttributeAnchorSelector(PAPERWORK_PROCESS_WO_ANCHOR_ATTR, anchorKey)}
      onClose={onClose}
      panelWidth={WORK_ORDER_DETAIL_CALLOUT_WIDTH_PX}
      scrollMode="smart"
      ariaLabel={`Work order ${buildOrderId}`}
      measureKey={`${buildOrderId}-${layoutEpoch}`}
    >
      <WorkOrderDetailWorkspace
        buildOrderId={buildOrderId}
        onClose={onClose}
        showHeaderClose={false}
        onMutated={onMutated}
        onDetailReady={onDetailReady}
      />
    </AnchoredDetailCallout>
  );
}
